import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useOverlayActions } from '../../contexts/StoreContext';
import { createPortal } from 'react-dom';
import { Toaster } from 'sonner';
import { CatalogProvider } from '../../contexts/CatalogContext';
import { StoreProvider } from '../../contexts/StoreContext';
import { AccountProvider } from '../../contexts/AccountContext';
import { CartServerSync } from '../../contexts/CartServerSync';
import { CatalogFallback } from '../shared/CatalogFallback';
import { Seo } from '../seo/Seo';
import { SiteFrame } from './SiteFrame';
import { AnalyticsScript } from './AnalyticsScript';
import { TOAST_LAYER } from '../../ui/layers';
import { prunePending } from '../checkout/orderStorage';
import { ForgetOrderOnSignOut } from '../checkout/ForgetOrderOnSignOut';

/** Nieuwe pagina = bovenaan. Met een ankertje (bijv. `/algemene-voorwaarden#reviews`) naar dat stuk. */
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    const target = hash.length > 1 ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
    if (target) target.scrollIntoView({
      block: 'start'
    });else window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname, hash]);
  return null;
}

/**
 * Naar een andere pagina = alle lades dicht. Anders bleef bijv. het huidadvies over de
 * afrekenpagina hangen. Alleen bij een echte wissel van pad, niet bij de eerste keer laden.
 */
function CloseOverlaysOnNavigate() {
  const {
    pathname
  } = useLocation();
  const {
    closeAll
  } = useOverlayActions();
  const previous = useRef(pathname);
  useEffect(() => {
    if (previous.current === pathname) return;
    previous.current = pathname;
    closeAll();
  }, [pathname, closeAll]);
  return null;
}

/** De publieke website: winkel, salon en journal. */
export function SiteShell() {
  // Een bevestiging die nooit terugkwam van de bank (naam, e-mail, regels): na een dag weg.
  useEffect(() => prunePending(), []);
  return <CatalogProvider fallback={(error, retry) => <CatalogFallback error={error} onRetry={retry} data-id="element-7959" data-mp="3as4u9mhybbjy" />} data-id="element-7958" data-mp="3atfytoj80nc4">
      <StoreProvider data-id="element-7960" data-mp="35uwd9p8jhdka">
        <AccountProvider data-id="element-7961" data-mp="35tl8bm3cxzrl">
          <ScrollToTop data-id="element-7962" data-mp="35ucr1wbuw30g" />
          <CloseOverlaysOnNavigate data-id="element-7963" data-mp="35ss68yfcfyfs" />
          <AnalyticsScript data-id="element-7964" data-mp="3kjshtcbe08g5" />
          <CartServerSync data-id="element-7965" data-mp="3kiziuxio6n8k" />
          <ForgetOrderOnSignOut data-id="element-7966" data-mp="3kld98t2enb9s" />
          <Seo data-id="element-7967" data-mp="3fjwelfaikl1n" />
          <SiteFrame data-id="element-7968" data-mp="3flh76zd9ptwv" />
          {/* Buiten de pagina gezet, zodat meldingen bereikbaar blijven als een lade open is (Drawer maakt de rest inert). */}
          {createPortal(<div data-toaster-root="" data-id="element-7969" data-mp="2mwa6btqccs8g">
              <Toaster position="bottom-right" offset={24} duration={4000} style={{
            zIndex: TOAST_LAYER
          }} toastOptions={{
            classNames: {
              toast: 'bg-shell border border-line border-l-2 border-l-clay text-ink font-sans rounded-none shadow-[0_12px_32px_-12px_rgba(0,0,0,0.18)] gap-3 px-5 py-4',
              icon: 'text-clay',
              title: 'text-[14px] text-ink',
              description: 'text-[13px] text-muted',
              actionButton: 'bg-ink text-shell rounded-full text-[12px] px-3 py-1.5'
            }
          }} data-id="element-7970" data-mp="2mxbloaee40vz" />
            </div>, document.body)}
        </AccountProvider>
      </StoreProvider>
    </CatalogProvider>;
}